module.exports = __webpack_public_path__ + "img/spiel4.2e40ff4a.jpg";